import { Chip, ImageWrapper, useGlobalCmsContentContext } from '@module/mdrt-org/shared/components';
import { type MembershipToolkitTabs } from '@module/mdrt-org/shared/utils/types';
import { ArticleIcon, Card, ChipTheme } from '@shared/ui-components';

import { type LinksListItem } from '../../get-membership-toolkit-content';

import styles from './toolkit-item-card.module.scss';

export const ToolkitItemCard = ({
  LinksListSectionTitle,
  MembershipToolkitTabsSectionTitle,
  link,
  sendMemberToolkitIntoGTM,
}: {
  LinksListSectionTitle: string;
  MembershipToolkitTabsSectionTitle: string;
  link: LinksListItem;
  sendMemberToolkitIntoGTM: (data: MembershipToolkitTabs) => void;
}) => {
  const { cmsContent } = useGlobalCmsContentContext();

  // eslint-disable-next-line complexity
  const renderContent = (mimeType: string) => {
    switch (mimeType) {
      case 'image/jpeg':
      case 'image/png':
      case 'image/gif':
      case 'image/bmp':
      case 'image/svg+xml':
      case 'image/tiff':
      case 'image/webp':
        return (
          <ImageWrapper
            alt={link.DisplayText}
            className={styles['toolkit-item-card__image']}
            height={450}
            quality={100}
            sizes="(min-width: 1300px) 300px, (min-width: 940px) 30vw, (min-width: 380px) 50vw, 34vw"
            src={link.LinkToContent}
            width={450}
          />
        );
      case 'application/pdf':
        return <ArticleIcon className={styles['toolkit-item-card__icon']} />;
      case 'text/csv':
      case 'application/vnd.oasis.opendocument.spreadsheet':
      case 'application/vnd.ms-excel':
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return <ArticleIcon className={styles['toolkit-item-card__icon']} />;
      case 'application/msword':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      case 'application/vnd.oasis.opendocument.text':
      case 'application/rtf':
        return <ArticleIcon className={styles['toolkit-item-card__icon']} />;
      case 'application/vnd.oasis.opendocument.presentation':
      case 'application/vnd.ms-powerpoint':
      case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        return <ArticleIcon className={styles['toolkit-item-card__icon']} />;
      case 'application/gzip':
      case 'application/x-gzip':
      case 'application/vnd.rar':
      case 'application/zip':
      case 'application/x-zip-compressed':
      case 'application/x-7z-compressed':
        return <ArticleIcon className={styles['toolkit-item-card__icon']} />;
      default:
        return <ArticleIcon className={styles['toolkit-item-card__icon']} />;
    }
  };

  return (
    <Card className={styles['toolkit-item-card']}>
      {
        renderContent('image/jpeg') // todo replace with actual mime type
      }
      <div className={styles['toolkit-item-card__actions-container']}>
        <Chip
          className={styles['toolkit-item-card__action']}
          label={link.DisplayText ?? cmsContent.downloadLabel}
          onClick={() =>
            sendMemberToolkitIntoGTM({
              LinksListSectionTitle,
              linkURL:
                link.ShouldDownload && link.DownloadFileName
                  ? `${link.LinkToContent}?download=${link.DownloadFileName}`
                  : link.LinkToContent,
              MembershipToolkitTabsSectionTitle,
            })
          }
          target={link.Target ?? '_blank'}
          theme={ChipTheme.Light}
          to={
            link.ShouldDownload && link.DownloadFileName
              ? `${link.LinkToContent}?download=${link.DownloadFileName}`
              : link.LinkToContent
          }
        />
      </div>
    </Card>
  );
};
